import React from "react";
import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from "recharts";
import { eur } from "./format";

const fmtAxis = (v) => (Math.abs(v) >= 1000 ? `${Math.round(v / 1000)}k` : `${v}`);

function TooltipBox({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const row = payload[0]?.payload || {};
  return (
    <div className="bg-white border border-slate-200 rounded-lg shadow-lg p-3 text-[12px] min-w-[220px]" data-testid="pnl-chart-tooltip">
      <div className="font-semibold text-slate-800 mb-1.5">{label}</div>
      <Row k="Buget lunar" v={eur(row.budget)} c="#94a3b8" />
      <Row k="Buget planificat din alocări" v={eur(row.planned_value)} c="#3d68b1" />
      <Row k="Buget realizat din pontaje" v={eur(row.actual_value)} c="#16a34a" />
      <div className="border-t border-slate-100 my-1.5" />
      <Row k="Buget cumulat" v={eur(row.budget_cum)} c="#475569" />
      <Row k="Plan cumulat" v={eur(row.planned_cum)} c="#3d68b1" />
      <Row k="Realizat cumulat" v={eur(row.actual_cum)} c="#16a34a" />
      <div className="border-t border-slate-100 my-1.5" />
      <Row k="Ore plan / real" v={`${row.planned_hours} h / ${row.actual_hours} h`} c="#64748b" />
    </div>
  );
}

function Row({ k, v, c }) {
  return (
    <div className="flex justify-between gap-4 py-0.5">
      <span className="flex items-center gap-1.5 text-slate-500"><span className="h-2 w-2 rounded-full" style={{ background: c }} />{k}</span>
      <span className="font-semibold tabular-nums text-slate-700">{v}</span>
    </div>
  );
}

export function PnlChart({ rows, currentMonth }) {
  const data = (rows || []).map((r) => ({ ...r, name: r.label }));
  return (
    <div className="h-[300px] w-full" data-testid="pnl-chart">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#e2e8f0" strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} />
          <YAxis yAxisId="m" tickFormatter={fmtAxis} tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} width={44} />
          <YAxis yAxisId="c" orientation="right" tickFormatter={fmtAxis} tick={{ fontSize: 11, fill: "#94a3b8" }} axisLine={false} tickLine={false} width={44} />
          <Tooltip content={<TooltipBox />} cursor={{ fill: "rgba(61,104,177,0.06)" }} />
          <Legend wrapperStyle={{ fontSize: 12 }} iconType="circle" iconSize={8} />
          <Bar yAxisId="m" dataKey="budget" name="Buget lunar" fill="#94a3b8" radius={[4, 4, 0, 0]} maxBarSize={28} />
          <Bar yAxisId="m" dataKey="planned_value" name="Buget planificat din alocări" fill="#3d68b1" radius={[4, 4, 0, 0]} maxBarSize={28} />
          <Bar yAxisId="m" dataKey="actual_value" name="Buget realizat din pontaje" fill="#16a34a" radius={[4, 4, 0, 0]} maxBarSize={28} />
          <Line yAxisId="c" type="monotone" dataKey="budget_cum" name="Buget cumulat" stroke="#475569" strokeDasharray="6 4" strokeWidth={2} dot={false} />
          <Line yAxisId="c" type="monotone" dataKey="planned_cum" name="Plan cumulat" stroke="#3d68b1" strokeWidth={2.5} dot={{ r: 2.5 }} />
          <Line yAxisId="c" type="monotone" dataKey="actual_cum" name="Realizat cumulat" stroke="#16a34a" strokeWidth={2.5} dot={{ r: 2.5 }} />
          {currentMonth && data.some((d) => d.month === currentMonth) && (
            <ReferenceLine yAxisId="m" x={data.find((d) => d.month === currentMonth)?.name} stroke="#d97706" strokeDasharray="4 4"
              label={{ value: "azi", position: "insideTopRight", fontSize: 10, fill: "#d97706" }} />
          )}
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
